import { Box, Button, Divider } from "@mui/material";
import React from "react";
import { useECSContext } from "../ecsContext";
import { navItems } from "./navItemms";

export default function Nav() {
  const { currentMrqNav, currentPoNav, currentTab, onSelectNavItem } =
    useECSContext();

  return (
    <Box sx={{ p: 0.5, textAlign: "center" }}>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
          overflow: "hidden",
          bgcolor: "background.paper",
          //   "& svg": {
          //     m: 1,
          //   },
        }}
      >
        {navItems.map((item, i) => {
          const isSelected =
            currentTab === 1
              ? currentMrqNav === item.label
              : currentPoNav === item.label;

          return (
            <React.Fragment key={item.label}>
              <Button
                sx={{
                  py: 1,
                  px: 2,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: isSelected
                      ? "primary.main"
                      : "hsla(250, 86%, 97%, 1)",
                  },
                  backgroundColor: isSelected && "primary.main",
                  color: isSelected && "white",
                }}
                onClick={() => onSelectNavItem({ item })}
              >
                {item.label}
              </Button>
              {i !== navItems.length - 1 && (
                <Divider orientation="vertical" variant="middle" flexItem />
              )}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
}
